import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { InternalGa4Actions } from '../actions'

interface ConnectResponse {
  url: string
}

// Изолированный сайд-эффект: OAuth-консент Google живёт только как top-level
// навигация, XHR-ом его не пройти.
const redirectToConsent = (url: string): void => {
  window.location.assign(url)
}

export function* connect() {
  const projectId: string | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === null) {
    return
  }

  yield put(InternalGa4Actions.connecting(true))

  try {
    const response: ConnectResponse = yield call(
      API.GoogleAnalytics.connect,
      projectId
    )

    yield call(redirectToConsent, response.url)
  } catch {
    yield put(InternalGa4Actions.connecting(false))
  }
}
